<button mat-button class="toolbar-icon-button dialog-closeicon" (click)="onCancel()">
    <mat-icon class="material-icons dialog-closeicon">
        close
    </mat-icon>
</button>
<div class="session-expired-container">
    <div fxLayout="column" fxLayoutAlign="center center" class="notranslate" fxLayoutGap="24px">
        <i class="fas fa-triangle-exclamation session-expired-clock"></i>
        <p class="goto-original-content notranslate" cdkFocusInitial>
            You will be navigated to the original website (in English).
        </p>
        <div>
            <button class="notranslate login-btn" mat-button (click)="goToOriginalPage()">
                <!-- <mat-icon style="margin-bottom: 2px;">language</mat-icon> -->
                <span class="notranslate">Confirm</span>
            </button>
        </div>
    </div>
</div>